import { useState } from 'react';

/**
 *
 * @param isAlwaysOpen if true will allow multiple accordions to be open at once.
 * @param initialState initial state of the accordion, which ids are open.
 */
const useAccordion = <T extends string>(
  isAlwaysOpen = true,
  initialState: Array<T> = [],
) => {
  const [openIds, setOpenIds] = useState<T[]>(initialState);

  const onChange = (id: T) => {
    if (checkIsOpen(id)) {
      if (isAlwaysOpen) {
        setOpenIds(openIds.filter((openId) => openId !== id));
      } else {
        setOpenIds([]);
      }
    } else {
      if (isAlwaysOpen) {
        setOpenIds([...openIds, id]);
      } else {
        setOpenIds([id]);
      }
    }
  };

  const checkIsOpen = (id: T) => {
    return openIds.includes(id);
  };

  return {
    onChange,
    checkIsOpen,
  };
};

export { useAccordion };
